import { render, staticRenderFns } from "./NotificationSentCardData.vue?vue&type=template&id=3b965d4b&scoped=true"
import script from "./NotificationSentCardData.vue?vue&type=script&lang=js"
export * from "./NotificationSentCardData.vue?vue&type=script&lang=js"
import style0 from "./NotificationSentCardData.vue?vue&type=style&index=0&id=3b965d4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b965d4b",
  null
  
)

export default component.exports